import ISite from "interfaces/models/ISiteHwrc";
import {
  ListGroup, Row, Col, Form
} from "react-bootstrap";

interface UserSiteItemProps {
  register : any;
  site: ISite;
}

const UserSiteItem = ({
  register, site, ...props
} : UserSiteItemProps) => (
  <ListGroup.Item {...props}>
    <Row className="align-items-center">
      <Col xs={11}><Form.Label className="d-flex w-100 mb-0" htmlFor={`swRole_${site.siteId}`}>{site.siteName}</Form.Label></Col>
      <Col xs={1} className="d-flex justify-content-end">
        <Form.Check
          {...register("hwrcSites")}
          id={`swHwrcSite_${site.siteId}`}
          data-testid={`swAllocate_${site.siteId}`}
          className="d-inline-flex custom-switch custom-switch-md ms-2"
          type="switch"
          aria-required="false"
          aria-label={`${site.siteName} site`}
          value={site.siteId}
        />
      </Col>
    </Row>
  </ListGroup.Item>
);

export default UserSiteItem;
